import React from 'react';
import Select, { StylesConfig, ControlProps } from 'react-select';
import { CSSObject } from '@emotion/react';
import { Props as DropdownProps } from '../Dropdown';

type OptionType = {
  label: string;
  value: string | number | readonly string[] | undefined;
};

type IsMulti = false;

const selectStyle: StylesConfig<OptionType, IsMulti> = {
  control: (provided: CSSObject, _state: ControlProps<OptionType, IsMulti>): CSSObject => ({
    ...provided,
    marginBottom: '5px',
    minWidth: '230px',
  }),
};

const theme = {
  colors: {
    primary: '#2684FF',
    primary75: '#66afe9',
    primary50: '#66afe9',
    primary25: '#66afe9',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: '#a8b0b8',
    neutral5: '#eeeeee',
    neutral10: '#a8b0b8',
    neutral20: '#ffffff',
    neutral30: '#2684FF',
    neutral40: '#66afe9',
    neutral50: '#ffffff',
    neutral60: '#ffffff',
    neutral70: '#DE350B',
    neutral80: '#ffffff',
    neutral90: '#DE350B',
  },
  borderRadius: 4,
  spacing: {
    baseUnit: 2,
    controlHeight: 32,
    menuGutter: -5,
  },
};

export const SearchableDropdown: React.FC<DropdownProps<string>> = ({
  id,
  name,
  placeholder,
  value,
  error = false,
  options = [],
  onChange,
  className,
  disabled = false,
}) => {
  const adjustedTheme = { ...theme };

  if (error) {
    adjustedTheme.colors = {
      ...adjustedTheme.colors,
      neutral10: adjustedTheme.colors.danger,
      neutral20: adjustedTheme.colors.dangerLight,
    };
  }

  const selectedOption = options.find(option => option.value === value);
  // re-map options from our DropdownOption type to the react-select option type
  const reMappedOptions = options?.map?.(option => ({
      value: option.value,
      label: option.text,
    }));

  return (
    <Select
      className={className}
      id={id}
      isDisabled={disabled}
      isSearchable
      isClearable
      name={name || id}
      options={reMappedOptions}
      placeholder={selectedOption?.text ?? placeholder}
      styles={selectStyle}
      theme={adjustedTheme}
      value={selectedOption?.value ?? null as any}
      onChange={option => onChange(option?.value ?? '')}
    />
  );
};
